<template>
  <div :class="['card-intro']">
    <div class="card-intro__description">
      <div class="card-intro__description__imgContainer">
        <img class="card-intro__description__imgContainer--img" :src="image" />
      </div>
      <div class="card-intro__description__info">
        <div class="card-intro__description__info__text">
          <span
            v-html="title"
            class="card-intro__description__info__text--title"
            :style="titleColor ? { color: titleColor } : null"
          ></span>
          <span
            v-html="subtitle"
            class="card-intro__description__info__text--subtitle"
            :style="subtitleColor ? { color: subtitleColor } : null"
          ></span>
        </div>
        <div class="card-intro__description__info__action">
          <slot name="action"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    title: String,
    subtitle: String,
    image: String,
    widthMobile: { type: String, default: '100%' },
    heightMobile: { type: String, default: '100%' },
    width: { type: String, default: '100%' },
    height: { type: String, default: '100%' },
    justify: { type: String, default: 'flex-start' },
    align: { type: String, default: 'initial' },
    // Colores del gestor; vacios = los de siempre (--theme-color)
    titleColor: { type: String, default: '' },
    subtitleColor: { type: String, default: '' }
  })

  const cardWidth = computed(() => props.width)
  const cardHeight = computed(() => props.height)
</script>

<style lang="scss">
  @import '@/scss/mixings';

  .card-intro {
    width: v-bind(widthMobile);
    height: v-bind(heightMobile);
    position: relative;
    @media screen and (min-width: $sm-breakpoint) {
      width: v-bind(width);
      height: v-bind(height);
    }
    &__description {
      @include d-flex(column, v-bind(justify), v-bind(align));
      height: 100%;
      gap: 10px;

      &__info {
        @include d-flex(column, v-bind(justify), v-bind(align));
        height: 100%;
        gap: 30px;
        position: relative;
        padding: 50px 40px;
        &__text {
          @include d-flex(column, v-bind(justify), v-bind(align));
          gap: 10px;
          &--title {
            font-family: 'OnAir-text-black';
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
            line-height: 32px;
            color: var(--theme-color);
            z-index: 20;
          }
          &--subtitle {
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            color: var(--theme-color);
            z-index: 20;
          }
        }
        &__action {
          z-index: 20;
          @media screen and (min-width: $sm-breakpoint) {
            width: 165px;
          }
        }
      }
      &__imgContainer {
        width: 100%;
        position: absolute;
        top: 0;
        height: 100%;
        &--img {
          width: 100%;
          height: inherit;
          min-height: 100%;
          object-fit: fill;

          @media screen and (min-width: $sm-breakpoint) {
            object-fit: cover;
            @media (orientation: portrait) {
              object-position: top;
            }
          }
        }
      }
    }
  }
</style>
